/**
 * Normalize a string for user-typed searching: lowercase, strip accents
 * (diacritics), and expand ligatures so that e.g. "creme" matches "Crème"
 * and "boeuf" matches "Bœuf". Ligatures like "œ" are distinct letters with
 * no Unicode decomposition, so they need explicit replacements, as do the
 * curly apostrophes and non-breaking spaces common in pasted French text.
 */
// eslint-disable-next-line import/prefer-default-export
export const normalizeForSearch = (text: string): string =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/œ/g, "oe")
    .replace(/æ/g, "ae")
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u00a0\u202f]/g, " ");
